/**
 * Modo de cor da interface: claro ou escuro.
 *
 * A Kumo resolve as cores pelo atributo `data-mode` do documento, com `light-dark()` nos
 * tokens — trocar o modo é trocar um atributo, sem recarregar nada. O que mora aqui é a
 * decisão pura de qual modo usar, verificável por teste.
 */

/** Os dois modos suportados. */
export type ThemeMode = "light" | "dark";

/** Chave de armazenamento local da escolha do usuário. */
export const THEME_STORAGE_KEY = "benchboard:theme-mode";

/**
 * Modo inicial a partir do que foi guardado.
 *
 * Escuro é o padrão: é um painel de observabilidade, olhado por horas durante campanha.
 * Valor guardado desconhecido (versão antiga, edição à mão) cai no padrão em vez de
 * quebrar a tela.
 */
export function resolveThemeMode(stored: string | null): ThemeMode {
  return stored === "light" ? "light" : "dark";
}

/** O modo oposto ao corrente. */
export function toggleThemeMode(mode: ThemeMode): ThemeMode {
  return mode === "dark" ? "light" : "dark";
}
